// Auto-generated by tools/avatar/generate-top-svgs.mjs
 
import type { RecordOfTopComponents } from './types';

import NoHairSvg from './no-hair.svg?raw'
import EyepatchSvg from './eyepatch.svg?raw'
import HatSvg from './hat.svg?raw'
import HijabSvg from './hijab.svg?raw'
import TurbanSvg from './turban.svg?raw'
import WinterHat1Svg from './winter-hat-1.svg?raw'
import WinterHat2Svg from './winter-hat-2.svg?raw'
import WinterHat3Svg from './winter-hat-3.svg?raw'
import WinterHat4Svg from './winter-hat-4.svg?raw'
import LongHairBigHairSvg from './long-hair-big-hair.svg?raw'
import LongHairBobSvg from './long-hair-bob.svg?raw'
import LongHairBunSvg from './long-hair-bun.svg?raw'
import LongHairCurlySvg from './long-hair-curly.svg?raw'
import LongHairCurvySvg from './long-hair-curvy.svg?raw'
import LongHairDreadsSvg from './long-hair-dreads.svg?raw'
import LongHairFridaSvg from './long-hair-frida.svg?raw'
import LongHairFroSvg from './long-hair-fro.svg?raw'
import LongHairFroBandSvg from './long-hair-fro-band.svg?raw'
import LongHairNotTooLongSvg from './long-hair-not-too-long.svg?raw'
import LongHairShavedSidesSvg from './long-hair-shaved-sides.svg?raw'
import LongHairMiaWallaceSvg from './long-hair-mia-wallace.svg?raw'
import LongHairStraightSvg from './long-hair-straight.svg?raw'
import LongHairStraight2Svg from './long-hair-straight-2.svg?raw'
import LongHairStraightStrandSvg from './long-hair-straight-strand.svg?raw'
import ShortHairDreads01Svg from './short-hair-dreads-01.svg?raw'
import ShortHairDreads02Svg from './short-hair-dreads-02.svg?raw'
import ShortHairFrizzleSvg from './short-hair-frizzle.svg?raw'
import ShortHairShaggyMulletSvg from './short-hair-shaggy-mullet.svg?raw'
import ShortHairShortCurlySvg from './short-hair-short-curly.svg?raw'
import ShortHairShortFlatSvg from './short-hair-short-flat.svg?raw'
import ShortHairShortRoundSvg from './short-hair-short-round.svg?raw'
import ShortHairShortWavedSvg from './short-hair-short-waved.svg?raw'
import ShortHairSidesSvg from './short-hair-sides.svg?raw'
import ShortHairTheCaesarSvg from './short-hair-the-caesar.svg?raw'
import ShortHairTheCaesarSidePartSvg from './short-hair-the-caesar-side-part.svg?raw'

export const topComponents = {
  NoHair: NoHairSvg,
  Eyepatch: EyepatchSvg,
  Hat: HatSvg,
  Hijab: HijabSvg,
  Turban: TurbanSvg,
  WinterHat1: WinterHat1Svg,
  WinterHat2: WinterHat2Svg,
  WinterHat3: WinterHat3Svg,
  WinterHat4: WinterHat4Svg,
  LongHairBigHair: LongHairBigHairSvg,
  LongHairBob: LongHairBobSvg,
  LongHairBun: LongHairBunSvg,
  LongHairCurly: LongHairCurlySvg,
  LongHairCurvy: LongHairCurvySvg,
  LongHairDreads: LongHairDreadsSvg,
  LongHairFrida: LongHairFridaSvg,
  LongHairFro: LongHairFroSvg,
  LongHairFroBand: LongHairFroBandSvg,
  LongHairNotTooLong: LongHairNotTooLongSvg,
  LongHairShavedSides: LongHairShavedSidesSvg,
  LongHairMiaWallace: LongHairMiaWallaceSvg,
  LongHairStraight: LongHairStraightSvg,
  LongHairStraight2: LongHairStraight2Svg,
  LongHairStraightStrand: LongHairStraightStrandSvg,
  ShortHairDreads01: ShortHairDreads01Svg,
  ShortHairDreads02: ShortHairDreads02Svg,
  ShortHairFrizzle: ShortHairFrizzleSvg,
  ShortHairShaggyMullet: ShortHairShaggyMulletSvg,
  ShortHairShortCurly: ShortHairShortCurlySvg,
  ShortHairShortFlat: ShortHairShortFlatSvg,
  ShortHairShortRound: ShortHairShortRoundSvg,
  ShortHairShortWaved: ShortHairShortWavedSvg,
  ShortHairSides: ShortHairSidesSvg,
  ShortHairTheCaesar: ShortHairTheCaesarSvg,
  ShortHairTheCaesarSidePart: ShortHairTheCaesarSidePartSvg,
} satisfies RecordOfTopComponents;

export type TopComponentName = keyof typeof topComponents;
